import ReactDOM from 'react-dom';
import React from 'react';

import loadTranslations from '@utils/localeSetup';
import HeaderContainer from './Header.Container';

(async () => {
  const rootElement = document.getElementById('header');
  await loadTranslations();

  if (rootElement) {
    ReactDOM.render(<HeaderContainer />, rootElement);
  }
})();
